var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiempo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.134,
    height: 17.134,
    viewBox: "0 0 17.134 17.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7270",
    "data-name": "Path 7270",
    d: "M8.556,17.133a8.567,8.567,0,1,1,8.578-8.551A8.555,8.555,0,0,1,8.556,17.133ZM9.424,6.059V4.371a1.188,1.188,0,0,0-.038-.338.858.858,0,0,0-.927-.605.847.847,0,0,0-.739.863c-.005,1.42,0,2.84,0,4.259a.866.866,0,0,0,.52.814c.418.209.836.418,1.259.627.7.348,1.4.707,2.1,1.05a.855.855,0,0,0,1.259-.67.864.864,0,0,0-.52-.873Q10.973,8.807,9.6,8.127a.251.251,0,0,1-.166-.273C9.424,7.253,9.424,6.653,9.424,6.059Z",
    transform: "translate(0 0.001)",
    fill: "#3177be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiempo);
export default __webpack_public_path__ + "static/media/tiempo.b25d3a21b469a652172f8c43d5eefe96.svg";
export { ForwardRef as ReactComponent };